import { v4 } from 'uuid'

export function uuid(): string {
  return v4()
}

export function getRandomInt(min: number, max: number): number {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export function getFileName(file: string) {
  const fileStr = file.split('/')
  const realFileName = fileStr[fileStr.length - 1].replace(/(CiU=|Cis=)/g, ($0, $1) => {
    return {
      'CiU=': '%',
      'Cis=': '+',
    }[$1]
  })
  const filesIndex = realFileName.indexOf('_')
  if (filesIndex > -1) {
    return realFileName.slice((filesIndex + 1))
  }
  return realFileName
}
/**
 * 获取文件拓展名
 *
 * @param val
 * @returns {string} '' | .文件类型
 */
export function getFileType(val?: string): string {
  if (!val) return ''
  const reg = /\.[^.]+$/
  const r = val.match(reg)
  if (r?.length) {
    return r[0].toLocaleLowerCase()
  }
  return ''
}

export function getUrlQuery(name: string) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
  const r = window.location.search.substring(1).match(reg)
  if (r != null) {
    return decodeURI(r[2])
  }
}

export function getStringByte(val: string) {
  return new Blob([val]).size
}

export function desensitizeIdNumber(val: string) {
  if (!val) return ''
  return val.replace(/^(\d{4})\d+(\d{4})$/, '$1**********$2')
}
